import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8fc6abcc&scoped=true&lang=true&"
import script from "./filterManga?vue&type=script&lang=js&"
export * from "./filterManga?vue&type=script&lang=js&"
import style0 from "../../Watching/FilterFilm/filter.scss?vue&type=style&index=0&id=8fc6abcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc6abcc",
  null
  
)

export default component.exports